import { render, staticRenderFns } from "./jiejingdtList.vue?vue&type=template&id=ecb9585e&scoped=true&"
import script from "./jiejingdtList.vue?vue&type=script&lang=js&"
export * from "./jiejingdtList.vue?vue&type=script&lang=js&"
import style0 from "./jiejingdtList.vue?vue&type=style&index=0&id=ecb9585e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecb9585e",
  null
  
)

export default component.exports